import React, { useState } from "react";
import { colors } from "../../../../../themes/Colors";
import { BaseButtonsIcon } from "../../../../common-components";

const Menu = ({
  onVehicleClick,
  onOffenceClick,
  onTaskClick,
  onNoticeClick,
  onMoreClick,
  onBuzzClick,
  selected,
}) => {
  const [shrink, setShrink] = useState(false);
  return (
    <div
      style={{
        height: "100%",
        width: shrink ? 85 : 210,

        transition: "all 0.4s",
        display: "flex",
        flexDirection: "column",
        backgroundColor: shrink ? colors.white : colors.white,
        WebkitBoxShadow: "0px 0px 15px 5px #00000040",
        justifyContent: "flex-start",
        alignItems: "center",
        zIndex: 10,
      }}
    >
      <div onClick={() => setShrink(shrink ? false : true)}>
        <div
          style={{
            color: shrink ? colors.primaryBlue : colors.primaryBlue,
            fontSize: shrink ? 22 : 32,
            fontWeight: "bold",
            transition: "all 0.3s",
            marginLeft: shrink ? 0 : 0,
            marginTop: shrink ? 0 : 0,
            transform: shrink ? `rotate(180deg)` : `rotate(90deg)`,
            cursor: "pointer",
            marginBottom: shrink ? 40 : 60,
            zIndex: 0,
          }}
        >
          <img
            alt="logo"
            src={
              shrink
                ? require("../../../../../images/base-logo-desgns/driverfrinedIcon1.png")
                : require("../../../../../images/base-logo-desgns/driverfrinedlogo4.png")
            }
            style={{
              width: shrink ? 100 : "100%",
              transform: shrink ? `rotate(180deg)` : `rotate(-90deg)`,
            }}
          />
        </div>
      </div>
      <BaseButtonsIcon
        label={"NOTIFICATIONS"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "notice" ? colors.primaryBlue : colors.greenLight
        }
        borderRadius={8}
        icon2={require("../../../../../images/icons/notificationsWhite.png")}
        icon={require("../../../../../images/icons/notificationsWhite.png")}
        iconHeight={shrink ? 30 : 30}
        iconWidth={shrink ? 30 : 30}
        shrink={shrink ? 18 : shrink}
        shrinkColor={
          selected === "notice" ? colors.primaryBlue : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onNoticeClick}
      />
      <BaseButtonsIcon
        label={"VEHICLES"}
        width={shrink ? "100%" : 150}
        backgroundColor={colors.greenLight}
        borderRadius={8}
        iconHeight={shrink ? 30 : 30}
        iconWidth={shrink ? 30 : 30}
        shrink={shrink}
        marginTop={shrink ? 18 : 10}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        icon2={require("../../../../../images/material-icon/whiteVehicle.png")}
        icon={require("../../../../../images/material-icon/whiteVehicle.png")}
        onClick={onVehicleClick}
        // disable={true}
      />
      <BaseButtonsIcon
        label={"OFFENCE"}
        width={shrink ? "100%" : 150}
        backgroundColor={colors.greenLight}
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteOffence.png")}
        icon={require("../../../../../images/material-icon/whiteOffence.png")}
        iconHeight={shrink ? 30 : 30}
        iconWidth={shrink ? 30 : 30}
        shrink={shrink}
        marginTop={shrink ? 18 : 10}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        onClick={onOffenceClick}
        disable={true}
      />
      <BaseButtonsIcon
        label={"TASKS"}
        width={shrink ? "100%" : 150}
        backgroundColor={colors.greenLight}
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteMarker.png")}
        icon={require("../../../../../images/material-icon/whiteMarker.png")}
        iconHeight={shrink ? 30 : 30}
        iconWidth={shrink ? 30 : 30}
        shrink={shrink}
        marginTop={shrink ? 18 : 10}
        shrinkColor={colors.greenDark}
        hoverColor={colors.greenDark}
        onClick={onTaskClick}
        disable={true}
      />

      <BaseButtonsIcon
        label={"BUZZ"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "buzz" ? colors.primaryBlue : colors.greenLight
        }
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteBee.png")}
        icon={require("../../../../../images/material-icon/whiteBee.png")}
        iconHeight={shrink ? 30 : 30}
        iconWidth={shrink ? 30 : 30}
        shrink={shrink}
        marginTop={shrink ? 18 : 10}
        shrinkColor={
          selected === "buzz" ? colors.primaryBlue : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onBuzzClick}
      />
      <BaseButtonsIcon
        label={"MORE"}
        width={shrink ? "100%" : 150}
        backgroundColor={
          selected === "more" ? colors.primaryBlue : colors.greenLight
        }
        borderRadius={8}
        icon2={require("../../../../../images/material-icon/whiteMore.png")}
        icon={require("../../../../../images/material-icon/whiteMore.png")}
        iconHeight={shrink ? 30 : 30}
        iconWidth={shrink ? 30 : 30}
        shrink={shrink}
        marginTop={shrink ? 18 : 10}
        shrinkColor={
          selected === "more" ? colors.primaryBlue : colors.greenLight
        }
        hoverColor={colors.greenDark}
        onClick={onMoreClick}
      />
    </div>
  );
};

export default Menu;
